"use client";

import styled from "styled-components";

export const TabMenuWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0;
`;
